(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/models/result-month.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/models/result-month.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const getDrawResultsDatepicker = svs.tur.apiCaller.drawgames.getDrawResultsDatepicker;
svs.numbergames.results.models.ResultMonth = svs.numbergames.core.NumbergamesModel.extend({
  defaults: {
    year: undefined,
    month: undefined,
    dates: {},
    productId: ''
  },
  async fetchAction(options) {
    const _this$attributes = this.attributes,
      month = _this$attributes.month,
      year = _this$attributes.year,
      productId = _this$attributes.productId;
    const datePickerMonth = month + 1;
    const productName = svs.numbergames.productMapping.getProductName(productId).toLowerCase();
    try {
      const requests = [getDrawResultsDatepicker({
        product: productName,
        year,
        month: datePickerMonth
      })];
      if (svs.numbergames.productMapping.hasJoker(productId)) {
        requests.push(getDrawResultsDatepicker({
          product: 'joker',
          year,
          month: datePickerMonth
        }));
      }
      const _await$Promise$all = await Promise.all(requests),
        _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
        response = _await$Promise$all2[0],
        addonResponse = _await$Promise$all2[1];
      options.success({
        datePicker: response.response,
        addonDatePicker: addonResponse === null || addonResponse === void 0 ? void 0 : addonResponse.response
      });
    } catch (error) {
      options.error(error);
    }
  },
  parse(attrs) {
    let datePicker;
    let addonDatePicker;
    if (attrs.datePicker) {
      datePicker = attrs.datePicker;
      addonDatePicker = attrs.addonDatePicker;
    } else if (attrs.responses) {
      var _attrs$responses = _slicedToArray(attrs.responses, 2);
      datePicker = _attrs$responses[0];
      addonDatePicker = _attrs$responses[1];
    } else {
      datePicker = attrs;
    }
    return {
      year: datePicker.year,
      month: datePicker.month - 1,
      dates: svs.numbergames.results.parsers.datePicker.parseDates(datePicker, addonDatePicker) || {},
      productId: svs.numbergames.productMapping.getProductId(datePicker.product)
    };
  },
  getAvailableDates() {
    const _this$attributes2 = this.attributes,
      year = _this$attributes2.year,
      month = _this$attributes2.month,
      dates = _this$attributes2.dates;
    const drawDates = [];

    for (const date in dates) {
      drawDates.push([year, month, Number(date)]);
    }
    return drawDates;
  },
  getLatestDraw() {
    const drawDates = Object.keys(this.get('dates')).sort((a, b) => a - b);
    return this.getDrawByDate(drawDates.pop());
  },
  getDrawByDate(dayOfMonth) {
    const dates = this.get('dates');
    return dates[dayOfMonth];
  }
});

 })(window);